import { Injectable } from '@angular/core';
import { EnvironmentService } from '../core/environment/environment.service';

@Injectable()
export class AuthenticationService {
  private accessToken: string | null = null;
  private refreshTokenPromise: Promise<boolean> | null = null;

  constructor(private environmentService: EnvironmentService) {}

  getAccessToken(): string | null {
    return this.accessToken;
  }

  clearAccessToken(): void {
    this.accessToken = null;
  }

  async refreshTokenOrRedirect(): Promise<void> {
    const ok = await this.refreshToken();
    if (!ok) {
      this.clearAccessToken();
      this.login();
    }
  }

  login(): void {
    window.location.href = this.environmentService.ponchBaseApiUrl + 'login?callback=' + btoa(window.location.href);
  }

  async refreshToken(): Promise<boolean> {
    if (this.refreshTokenPromise) {
      return this.refreshTokenPromise;
    }
    this.refreshTokenPromise = this.doRefreshToken();
    try {
      return await this.refreshTokenPromise;
    } finally {
      this.refreshTokenPromise = null;
    }
  }

  async logout(): Promise<void> {
    const token = this.accessToken;
    this.clearAccessToken();

    const loginUrl = this.environmentService.ponchBaseApiUrl + 'login?callback=' + btoa(window.location.href);

    if (token) {
      const revokeUrl = this.environmentService.ponchBaseApiUrl + 'api/v1/revoke-token';
      try {
        await fetch(revokeUrl, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
      } catch {
        // Ignora errori: redirect comunque al login
      }
    }

    window.location.href = loginUrl;
  }

  private async doRefreshToken(): Promise<boolean> {
    const url = this.environmentService.ponchBaseApiUrl + 'api/v1/refresh-token';
    try {
      const res = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
      });
      if (!res.ok) {
        return false;
      }
      const data = await res.json();
      this.accessToken = data.accessToken ?? null;
      return this.accessToken != null;
    } catch {
      return false;
    }
  }
}
